// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';
	
	if (document.cookie.indexOf('modal_shown=') == '-1') {
		var element = document.getElementById('landingModal');
		if (typeof(element) != 'undefined' && element != null) {
			var landingModal = new bootstrap.Modal(document.getElementById('landingModal'), {});
			landingModal.toggle();
			document.cookie = 'modal_shown=seen';
		}
	}
	
	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
	
	var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
	var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	  return new bootstrap.Tooltip(tooltipTriggerEl);
	});
	
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
	  return new bootstrap.Popover(popoverTriggerEl)
	});
	
	// Back to Top
	
	function trackScroll() {
		
		var scrolled = window.pageYOffset;
		var coords = document.documentElement.clientHeight;
		if (scrolled > coords) {
			goTopBtn.classList.add('btn-show');
			categoryBtn.classList.add('btn-show');
		}
		if (scrolled < coords) {
			goTopBtn.classList.remove('btn-show');
			categoryBtn.classList.remove('btn-show');
		}
	}
	
	function backToTop() {
		if (window.pageYOffset > 0) {
			document.documentElement.scrollTo({
				top: '0',
				behavior: 'smooth'
			});
			//window.scrollBy(0, -80);
			//setTimeout(backToTop, 0);
		}
	}
	
	var goTopBtn = document.querySelector('#btn-top');
	var categoryBtn = document.querySelector('#btn-category');
	
	window.addEventListener('scroll', trackScroll);
	goTopBtn.addEventListener('click', backToTop);
	
	function closest(el, selector) {
		var matchesFn;
	
		// find vendor prefix
		['matches','webkitMatchesSelector','mozMatchesSelector','msMatchesSelector','oMatchesSelector'].some(function(fn) {
			if (typeof document.body[fn] == 'function') {
				matchesFn = fn;
				return true;
			}
			return false;
		})
	
		var parent;
	
		// traverse parents
		while (el) {
			parent = el.parentElement;
			if (parent && parent[matchesFn](selector)) {
				return parent;
			}
			el = parent;
		}
	
		return null;
	}
	
	document.addEventListener('click', function (event) {
		// If the clicked element doesn't have the right selector, bail
		if (!event.target.closest('.mims-table-image')) return;
		// Don't follow the link
		event.preventDefault();
		// Log the clicked element in the console
		//console.log(event.target.closest('.mims-table-image'));
		event.target.closest('.accordion-body').querySelector('.mims-table-image').classList.add('d-none');
		event.target.closest('.accordion-body').querySelector('.mims-table').classList.remove('d-none');
	
	}, false);
	
	document.addEventListener('click', function (event) {
		// If the clicked element doesn't have the right selector, bail
		if (!event.target.closest('.mims-table-hide-btn')) return;
		// Don't follow the link
		event.preventDefault();
		// Log the clicked element in the console
		//console.log(event.target.closest('.mims-table-image'));
		event.target.closest('.accordion-body').querySelector('.mims-table').classList.add('d-none');
		event.target.closest('.accordion-body').querySelector('.mims-table-image').classList.remove('d-none');
				
	}, false);
} )();